import { render, staticRenderFns } from "./ToProcessFile.vue?vue&type=template&id=eaffe472&scoped=true"
import script from "./ToProcessFile.vue?vue&type=script&lang=ts"
export * from "./ToProcessFile.vue?vue&type=script&lang=ts"
import style0 from "./ToProcessFile.vue?vue&type=style&index=0&id=eaffe472&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaffe472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eaffe472')) {
      api.createRecord('eaffe472', component.options)
    } else {
      api.reload('eaffe472', component.options)
    }
    module.hot.accept("./ToProcessFile.vue?vue&type=template&id=eaffe472&scoped=true", function () {
      api.rerender('eaffe472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/ToProcessFile.vue"
export default component.exports